import { Box, BoxProps, ColorOptions, ImageProps, Spacer } from '@jfs/ui-new'
import { FC } from 'react'
import { EmptyView } from '../../comps/EmptyView'
import Footer from '../../comps/Footer'
import { SectionList } from '../../comps/SectionList'
import { PAYMENT_MODE_SUBTYPES, THEME_PADDING } from '../../utils/constants'

interface WalletProps {
  theme: any
  instrumentsState: 'pending' | 'fulfilled' | 'rejected' | undefined
  fetchInstrumentApi: () => void
  initialLoading: boolean
  message: string
}

const Loader = ({ state, onRetry, message, show = false, theme }: any) => {
  return <EmptyView state={state} onRetry={onRetry} message={message} show={show} theme={theme} />
}

const TOneWallet: FC<WalletProps> = (props: WalletProps) => {
  const { theme, instrumentsState, fetchInstrumentApi, initialLoading, message } = props

  const styles = walletStyles(theme)
  const BTNFooter = () => {
    return (
      <>
        <Spacer size={24} />
        <Footer />
      </>
    )
  }

  if (instrumentsState === 'pending' || instrumentsState === 'rejected' || initialLoading) {
    return (
      <Loader
        state={instrumentsState}
        onRetry={fetchInstrumentApi}
        message={message}
        show={instrumentsState === 'pending' || initialLoading}
        theme={theme}
      />
    )
  }

  return (
    <Box nativeID="showListScrollBar" {...styles.container}>
      <SectionList type={PAYMENT_MODE_SUBTYPES.WALLET} btnFooter={<BTNFooter />} />
    </Box>
  )
}

const walletStyles = (theme: any) => ({
  container: {
    flex: 1,
    backgroundColor: theme?.bodyBgColor as ColorOptions,
    overflowY: 'auto',
    paddingVertical: THEME_PADDING.VERTICAL_PADDING,
    paddingHorizontal: THEME_PADDING.HORIZONTAL_PADDING,
  } as BoxProps,
  imageView: {
    height: 24,
    width: 24,
  } as ImageProps,
})
export default TOneWallet
